import React, { Component } from 'react';
import { Translate } from '$common';



export default class Email extends Component {
  static type = 'email';
  static elementName = Translate.get('email');
  static icon = 'envelope-o';

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/task-form/question-types/email.js